import React, {useEffect, useState} from 'react'
import DownloadPDFButton from '../table/columns/DownloadPDFButton'
import {toAbsoluteUrl, generateAddress, capitalizeWords} from '../../../../../../_metronic/helpers'
import {useLocation} from 'react-router'
import {useListView} from '../core/ListViewProvider'
import QRCode from 'qrcode.react'
import {useFetchCommon} from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import {useAuth} from '../../../../auth'
import {FC, useRef} from 'react'
// import MapComponent from '../Map'
import MapComponentCerti from '../../Map'
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';

const CertificateComponent = ({data, passRef}) => {
  const {pathname} = useLocation()
  const {itemIdForUpdate} = useListView()
  const {isSupplyChainManager} = useAuth()

  const location = useLocation()
  const shouldShowMaterialDetails = location.pathname === '/apps/transactions/collect-orders'
  const shouldHideImage = location.pathname === '/apps/transactions/collect-orders'

  const isCollectOrders = pathname === '/apps/transactions/collect-orders'
  const isProcessingRecord =
    pathname.includes('processing-record') ||
    pathname === '/apps/plastic-credits/unaudited' ||
    pathname.includes('/apps/plastic-credits/audited')
  const isAudited = pathname === '/apps/plastic-credits/audited'
  const changeInProcessingRecord =
    (pathname.includes('processing-record') && itemIdForUpdate.showProductionReceipt) || false
  const isSupplyOrders =
    pathname.includes('supply-orders') || pathname.includes('/apps/transactions/items')
  const watermarkStyle: any = {
    position: 'relative', // Required for absolute positioning of watermark
    // backgroundImage: `url(${toAbsoluteUrl('/media/svg/files/blank-image.svg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '20%', // Adjust to your preference
  }
  const {responseData: diversionResponse} = useFetchCommon({
    api: `diversionCertificates/${data?.createdAt || ''}`,
    // isEnabled: isProcessingRecord,
    isEnabled: false,
    isDropDown: false,
  })

  const [displayData, setDisplayData] = useState<any>({})
  console.log('displayData', displayData)

  let addressArray: any = []
  if (data?.pickupPointInfo?.address?.state || data?.[0]?.dropOffPointInfo?.address?.state) {
    const responseAddress =
      data?.pickupPointInfo?.address || data[0]?.dropOffPointInfo?.address || {}
    const excludedProperties = ['latitute', 'longitute']
    const order = ['street', 'city', 'state', 'country']
    for (const key of order) {
      if (!excludedProperties.includes(key)) {
        const value = responseAddress[key] || ''
        if (value !== undefined) {
          addressArray.push(value)
        }
      }
    }
  }
  const formattedAddress = addressArray?.filter((item) => item !== '').join(', ') || ''

  // console.log({data, displayData}, Object.keys(data)?.length)
  useEffect(() => {
    if (data?.length > 0) {
      return setDisplayData(data[0])
    }
    if (data && Object.keys(data)?.length > 0) {
      return setDisplayData(data)
    }
  }, [data])
  const isReturnOrdersPage =
    pathname.includes('supply-orders') || pathname.includes('/apps/transactions/items')

  const {responseData: facilityList} = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT',
    isEnabled: false,
    isDropDown: false,
  })

  const [facilityData, setFacilityData] = useState<any>({})

  useEffect(() => {
    if (facilityList.length > 0) {
      const value = facilityList.filter((x) => x?.id === displayData?.pickupPointId)
      if (value?.length) {
        setFacilityData(value[0])
      }
    }
  }, [facilityList])

  function formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    const period = date.getHours() < 12 ? 'am' : 'pm'

    return `${year}-${month}-${day} ${hour}:${minute} ${period}`
  }

  const filterSpecificData = (data, name, key = 'docType', displayData = 'docUrl') => {
    return data?.filter((x) => x[key] === name)?.[0]?.[displayData] || ''
  }
  const diverisonName = [
    {label: 'Business name', value: displayData?.pickupPointName},
    {
      label: 'Address',
      value: isProcessingRecord ? formattedAddress || '' : displayData?.customerInfo?.mobile,
    },
    {
      label: 'Location',
      value:
        displayData?.pickupPointInfo?.address?.latitute +
          ' , ' +
          displayData?.pickupPointInfo?.address?.longitute || '',
    },
    // {
    //   label: 'Business License No',
    //   value: isProcessingRecord
    //     ? filterSpecificData(
    //       displayData?.pickupPointInfo?.kycDocument,
    //       'POE',
    //       'docType',
    //       'docNumber'
    //     )
    //     : displayData?.status,
    // },
    // {
    //   label: 'Company Reg No',
    //   value: isProcessingRecord
    //     ? filterSpecificData(
    //       displayData?.pickupPointInfo?.kycDocument,
    //       'POI',
    //       'docType',
    //       'docNumber'
    //     )
    //     : (displayData?.latitude || '') + ', ' + (displayData?.longitude || ''),
    // },
  ]

  const auditorInformation = [
    {label: 'Audit Company', value: displayData?.auditorInfo?.companyDetails?.name},
    {label: 'Regd. Address', value: displayData?.auditorInfo?.companyDetails?.address},
    {label: 'Auditor name', value: displayData?.auditorName},
    {label: 'ID', value: displayData?.auditorId},
  ]

  const depositerName = [
    {label: 'Supplier name', value: displayData?.customerInfo?.name},
    {label: 'Identification', value: displayData?.customerInfo?.mobile},
    // { label: 'Supplier type', value: displayData?.source },
    {
      label: 'Supplier type',
      value:
        pathname === '/apps/transactions/collect-orders'
          ? displayData?.customerInfo?.customerTypeDisplayName
          : displayData?.source,
    },
    {
      label: 'Collection date',
      value: displayData?.actualCollectionDate
        ? displayData.actualCollectionDate.substring(0, 10)
        : '',
    },
    // { label: 'Waste Type', value: displayData?.orderDetails?.[0]?.items?.[0]?.remark || '' },
    {
      label: 'Location',
      value: (displayData?.latitude || '') + ', ' + (displayData?.longitude || ''),
    },
  ]

  // const collectionData = [
  //   { label: 'Business name', value: displayData?.pickupInfo?.name },
  //   { label: 'Material Name', value: displayData?.orderDetails?.[0]?.categoryName || '' },
  //   {
  //     label: 'Order Date',
  //     value: new Date(displayData?.createdAt || new Date()).toLocaleDateString() || '',
  //   },
  //   { label: 'Plate Number', value: displayData?.vehicleNo || '' },
  //   { label: 'Status', value: displayData?.status || '' },
  //   {
  //     label: 'Geo co-ordinates',
  //     value:
  //       displayData?.pickupInfo?.address?.latitute +
  //       ' , ' +
  //       displayData?.pickupInfo?.address?.longitute || '',
  //   },
  // ]

  const collectionData = [
    // { label: 'Business name', value: displayData?.pickupInfo?.name },

    // { label: 'Business name', value: displayData?.pickupPointName },
    // { label: 'Address', value: displayData?.pickupInfo?.address?.street || '' },
    // {
    //   label: 'City',
    //   value: displayData?.pickupInfo?.address?.city || '',
    // },
    // { label: 'Country', value: displayData?.pickupInfo?.address?.country || '' },
    // { label: 'Dispatch date', value: displayData?.actualSupplyDate?.substring(0, 10) || '' },
    // {
    //   label: 'Geo co-ordinates',
    //   value:
    //     displayData?.pickupInfo?.address?.latitute +
    //     ' , ' +
    //     displayData?.pickupInfo?.address?.longitute || '',
    // },

    {label: 'Business name', value: displayData?.pickupPointName},
    {label: 'Address', value: displayData?.centreInfo?.address?.street || ''},
    {
      label: 'City',
      value: displayData?.centreInfo?.address?.city || '',
    },
    {label: 'Country', value: displayData?.centreInfo?.address?.country || ''},
    {label: 'Dispatch date', value: displayData?.actualSupplyDate?.substring(0, 10) || ''},
    {
      label: 'Geo co-ordinates',
      value:
        displayData?.centreInfo?.address?.latitute +
          ' , ' +
          displayData?.centreInfo?.address?.longitute || '',
    },
  ]

  const receivingFacility = [
    // {
    //   label: 'Business name',
    //   // value: displayData?.pickupInfo?.centreName,
    //   value: displayData?.converterName
    // },
    // {
    //   label: 'Address',
    //   // value:
    //   //   displayData?.centreInfo?.address?.street,
    //   value:
    //     displayData?.converterAddress?.street,
    // },
    // {
    //   label: 'City',
    //   // value: displayData?.centreInfo?.address?.city,
    //   value:
    //     displayData?.converterAddress?.city,
    // },

    {
      label: 'Business name',
      value:
        window.location.pathname === '/apps/transactions/items'
          ? displayData?.converterName
          : window.location.pathname === '/apps/transactions/supply-orders'
          ? displayData?.toPickupPointName
          : displayData?.pickupInfo?.centreName,
    },
    {
      label: 'Address',
      value:
        window.location.pathname === '/apps/transactions/items'
          ? displayData?.converterAddress?.street
          : window.location.pathname === '/apps/transactions/supply-orders'
          ? displayData?.toPickupPointAddress?.street
          : displayData?.centreInfo?.address?.street,
    },
    {
      label: 'City',
      value:
        window.location.pathname === '/apps/transactions/items'
          ? displayData?.converterAddress?.city
          : window.location.pathname === '/apps/transactions/supply-orders'
          ? displayData?.toPickupPointAddress?.city
          : displayData?.centreInfo?.address?.city,
    },
    // {
    //   label: 'Received On',
    //   // value: new Date(displayData?.completedAt || new Date()).toLocaleDateString(),
    //   value: displayData?.actualSupplyDate?.substring(0, 10) || '',
    // },
    // {
    //   label: 'Received qty',
    //   value: (() => {
    //     const totalReceived = displayData?.orderDetails?.[0]?.items?.reduce((total, item) => {
    //       const orderQty = item.quantity || 0;
    //       const transportLossItem = displayData?.transportationLoss?.[0]?.items?.find(
    //         lossItem => lossItem.itemId === item.itemId
    //       );
    //       const lossQty = transportLossItem?.quantity || 0;
    //       return total + (orderQty - lossQty);
    //     }, 0) || 0;

    //     return `${totalReceived.toFixed(2)} kg`;
    //   })()
    // },

    ...(location.pathname !== '/apps/transactions/items'
      ? [
          {
            label: 'Received On',
            value: displayData?.actualSupplyDate?.substring(0, 10) || '',
          },
          {
            label: 'Received qty',
            value: (() => {
              const totalReceived =
                displayData?.orderDetails?.[0]?.items?.reduce((total, item) => {
                  const orderQty = item.quantity || 0
                  const transportLossItem = displayData?.transportationLoss?.[0]?.items?.find(
                    (lossItem) => lossItem.itemId === item.itemId
                  )
                  const lossQty = transportLossItem?.quantity || 0
                  return total + (orderQty - lossQty)
                }, 0) || 0
              return `${totalReceived.toFixed(2)} kg`
            })(),
          },
        ]
      : []),
  ]
  const deliveryDetails = [
    {
      label: 'Recycler Name',
      value: displayData?.centreInfo?.name,
    },
    {
      label: 'Recycler Address',
      value:
        displayData?.centreInfo?.address?.street ||
        '' + '' + displayData?.centreInfo?.address?.city ||
        '' + '' + displayData?.centreInfo?.address?.state ||
        '',
    },
    {
      label: 'Receiving Date',
      value:
        (displayData?.pickupInfo?.pickupCompletedAt &&
          formatDate(new Date(parseInt(displayData.pickupInfo.pickupCompletedAt)))) ||
        '',
    },
  ]

  const lastSection = [
    {label: 'Company name', value: 'Evergreen Labs Philippines Consulting Inc'},
    {
      label: 'Regd Address',
      value:
        '6th Floor, One Ayala Avenue, Tower 2, Ayala Avenue, Ayala Center, San Lorenzo, City of Makati, Fourth District, National Capital Region (NCR), Philippines, 1223',
    },
  ]

  const subTotal = (data, withMultiply = false) => {
    if (!data) return 0
    return data.reduce(
      (accumulator, expense) =>
        accumulator + (withMultiply ? expense.quantity * expense.price : expense.quantity),
      0
    )
  }

  const diversionInformation = [
    {
      label: 'Date',
      value: new Date(displayData?.createdAt || new Date()).toLocaleDateString() || '',
    },
    // {
    //   label: 'Diversion Type',
    //   value: displayData?.processName || '',
    // },
    {
      label: 'Chain of custody',
      value: 'Batch traceability',
    },
    {
      label: 'Methodology',
      value: 'ISO 22095 [Mass balance]',
    },
    ...((!changeInProcessingRecord && [
      {
        label: 'Certificate Type',
        value: isAudited ? displayData.status : 'Unaudited',
      },
    ]) ||
      []),
    // {
    //   label: 'Certificate no',
    //   value: displayData?.productionId || '',
    // },
  ]
  const collectorDetails = [
    {
      label: 'Business name',
      value: displayData?.centreInfo?.name || '',
    },
    {
      label: 'Address',
      value: generateAddress(displayData?.centreInfo?.address) || '',
    },
    {
      label: 'Country',
      value: displayData?.centreInfo?.address?.country || '',
    },
  ]

  const handleClick = (image) => {
    passRef?.current?.open(image, itemIdForUpdate)
  }

  const certificateRef = useRef<HTMLDivElement>(null)

  // const downloadCertificate = () => {
  //   const printContent = certificateRef.current?.innerHTML;
  //   const originalContent = document.body.innerHTML;
  //   document.body.innerHTML = printContent || '';
  //   window.print();
  //   document.body.innerHTML = originalContent;
  //   window.location.reload();
  // };

  const downloadCertificate = () => {
    if (!certificateRef.current) return

    // Find all canvas elements (QR codes) and convert them to images
    const canvases = certificateRef.current.querySelectorAll('canvas')
    const canvasReplacements: {canvas: HTMLCanvasElement; img: HTMLImageElement}[] = []

    canvases.forEach((canvas) => {
      try {
        const img = document.createElement('img')
        img.src = canvas.toDataURL('image/png')
        img.width = canvas.width
        img.height = canvas.height
        img.style.cssText = canvas.style.cssText

        // Replace canvas with image temporarily
        canvas.parentNode?.insertBefore(img, canvas)
        canvas.style.display = 'none'

        canvasReplacements.push({canvas, img})
      } catch (error) {
        console.error('Error converting canvas to image:', error)
      }
    })

    // Wait for images to load
    setTimeout(() => {
      const printContent = certificateRef.current?.innerHTML
      const originalContent = document.body.innerHTML
      document.title = `${displayData?.createdAt || 'certificate'}_certificate`

      // const printStyles = `
      //   <style>
      //     body { font-family: Inter, Arial, sans-serif; margin: 20px; }
      //     .table { width: 100%; border-collapse: collapse; }
      //     .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
      //     .table th { background-color: #f8f9fa; font-weight: bold; }
      //     .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
      //     .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
      //     .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
      //     .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
      //     .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
      //     .col-11 { flex: 0 0 91.666667%; max-width: 91.666667%; padding: 0 15px; }
      //     .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
      //     .text-center { text-align: center; }
      //     .fw-bold { font-weight: bold; }
      //     img { max-width: 100%; height: auto; }
      //     .image-input-wrapper {
      //       background-size: cover;
      //       background-position: center;
      //       background-repeat: no-repeat;
      //     }
      //   </style>
      // `;

      // Add this before the downloadCertificate function
      const getBatchId = () => {
        return displayData?.createdAt || displayData?.orderDetails?.[0]?.batchId || 'certificate'
      }

      const printStyles = `
      <style>
        body { font-family: Inter, Arial, sans-serif; margin: 20px; }
        .table { width: 100%; border-collapse: collapse; }
        .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        .table th { background-color: #f8f9fa; font-weight: bold; }
        .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
        .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
        .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
        .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
        .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
        .col-11 { flex: 0 0 91.666667%; max-width: 91.666667%; padding: 0 15px; }
        .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
        .col-lg-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
        .col-lg-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
        .text-center { text-align: center; }
        .fw-bold { font-weight: bold; }
        .fs-6 { font-size: 1rem; }

        /* Prevent images from breaking across pages */
        img { 
          max-width: 100%; 
          height: auto; 
          page-break-inside: avoid;
          break-inside: avoid;
        }

        .image-input-wrapper {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          page-break-inside: avoid;
          break-inside: avoid;
        }

        .image-input {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        /* Remove the row page-break rule that was causing the empty first page */

        .row .col-lg-4 {
          display: inline-block;
          vertical-align: top;
          width: 33.333333%;
        }
        .row .col-lg-8 {
          display: inline-block;
          vertical-align: top;
          width: 66.666667%;
        }
      </style>
    `

      document.body.innerHTML = printStyles + (printContent || '')

      setTimeout(() => {
        window.print()

        // Restore original content
        document.body.innerHTML = originalContent

        // Restore canvas elements
        canvasReplacements.forEach(({canvas, img}) => {
          canvas.style.display = ''
          img.remove()
        })

        window.location.reload()
      }, 500)
    }, 1000)
  }

  // Alternative simpler approach - modify the existing div structure
  const downloadCertificateSimple = () => {
    if (!certificateRef.current) return

    // Find the certificate container
    const container = certificateRef.current

    // Store original background style
    const originalBackground = container.style.backgroundImage

    // Create background image element
    const bgImg = document.createElement('img')
    bgImg.src = '/BGImg.png'
    bgImg.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.1;
      z-index: -1;
      pointer-events: none;
    `

    // Remove background image style and add img element
    container.style.backgroundImage = 'none'
    container.style.position = 'relative'
    container.insertBefore(bgImg, container.firstChild)

    // Handle canvas elements
    const canvases = container.querySelectorAll('canvas')
    const canvasReplacements: {canvas: HTMLCanvasElement; img: HTMLImageElement}[] = []

    canvases.forEach((canvas) => {
      try {
        const img = document.createElement('img')
        img.src = canvas.toDataURL('image/png')
        img.width = canvas.width
        img.height = canvas.height
        img.style.cssText = canvas.style.cssText

        canvas.parentNode?.insertBefore(img, canvas)
        canvas.style.display = 'none'

        canvasReplacements.push({canvas, img})
      } catch (error) {
        console.error('Error converting canvas to image:', error)
      }
    })

    setTimeout(() => {
      const printContent = container.outerHTML
      const originalContent = document.body.innerHTML

      const printStyles = `
        <style>
          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
          
          body { 
            font-family: Inter, Arial, sans-serif; 
            margin: 20px;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          .table { width: 100%; border-collapse: collapse; }
          .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          .table th { background-color: #f8f9fa; font-weight: bold; }
          .row { display: flex; flex-wrap: wrap; margin: 0 -15px; }
          .col-3 { flex: 0 0 25%; max-width: 25%; padding: 0 15px; }
          .col-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
          .col-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
          .col-9 { flex: 0 0 75%; max-width: 75%; padding: 0 15px; }
          .col-11 { flex: 0 0 91.666667%; max-width: 91.666667%; padding: 0 15px; }
          .col-12 { flex: 0 0 100%; max-width: 100%; padding: 0 15px; }
          .col-lg-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
          .col-lg-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
          .text-center { text-align: center; }
          .fw-bold { font-weight: bold; }
          .fs-6 { font-size: 1rem; }
          
          img { 
            max-width: 100%; 
            height: auto; 
            page-break-inside: avoid;
            break-inside: avoid;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
        </style>
      `

      document.body.innerHTML = printStyles + printContent

      setTimeout(() => {
        window.print()

        setTimeout(() => {
          // Restore everything
          document.body.innerHTML = originalContent

          // This will trigger a re-render, but you might want to handle this differently
          window.location.reload()
        }, 1000)
      }, 500)
    }, 1000)
  }

  // const downloadCertificate = () => {
  //   if (certificateRef.current) {
  //     html2canvas(certificateRef.current, {
  //       scale: 2,
  //       useCORS: true,
  //       allowTaint: true,
  //       backgroundColor: '#ffffff'
  //     }).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       const imgWidth = 210;
  //       const pageHeight = 295;
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //       let heightLeft = imgHeight;
  //       let position = 0;

  //       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;

  //       while (heightLeft >= 0) {
  //         position = heightLeft - imgHeight;
  //         pdf.addPage();
  //         pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  //         heightLeft -= pageHeight;
  //       }

  //       pdf.save('certificate.pdf');
  //     });
  //   }
  // };

  const downloadPdfUrl =
    process.env.REACT_APP_BASE_API_URL +
    (pathname.includes('processing-record')
      ? `productionCertificate/download?productionId=${displayData?.productionId}`
      : `v1/certificate/download?orderId=${displayData?.id}&type=${
          pathname.includes('collect-orders') ? 'COLLECT' : 'RETURN'
        }`)

  const lineStyle = {
    marginTop: '1px',
    borderTop: '1px solid #000', // Adjust the color and width as needed
  }

  const calibrationCertifications = [
    {label: 'Weight Scale No', value: displayData?.weightScale?.productSerialNo},
    {
      label: 'Calibration On',
      value: displayData?.weightScale?.calibratedOn
        ? new Date(displayData?.weightScale?.calibratedOn).toLocaleDateString()
        : '',
      // displayData?.weightScale?.calibratedOn
    },
    {
      label: 'Make',
      value:
        (displayData?.weightScale?.make || '') + ', ' + (displayData?.weightScale?.model || ''),
    },
  ]
  const mapList: any = {
    collection: [
      {label: 'Activity', value: 'processName'},
      {label: 'Batch id', value: 'date'},
      {label: 'Material', value: 'name'},
      {label: 'Source', value: 'sourceName'},
      {label: 'Quantity', value: 'usedQuantity'},
      {label: 'Facility', value: 'pickupPointName'},
      {label: 'Country', value: 'country'},
    ],
    production: [
      // {label: 'Date', value: 'date'},
      // {label: 'Batch id', value: 'date'},
      // {label: 'Process name', value: 'processName'},
      // {label: 'Quantity', value: 'usedQuantity'},
      // {label: 'Country', value: 'country'},
      {label: 'Activity', value: 'processName'},
      {label: 'Batch id', value: 'date'},
      {label: 'Material', value: 'name'},
      {label: 'Source', value: 'sourceName'},
      {label: 'Quantity', value: 'usedQuantity'},
      {label: 'Facility', value: 'pickupPointName'},
      {label: 'Country', value: 'country'},
    ],
    proofOfDiversion: [
      {label: 'Date', value: 'date'},
      {label: 'Batch id', value: 'date'},
      {label: 'Process', value: 'process'},
      {label: 'Quantity', value: 'usedQuantity'},
      {label: 'Country', value: 'country'},
    ],
  }
  const dataMap = {
    collection: displayData?.collectionDetails || [],
    production: displayData?.processDetails || [],
    proofOfDiversion: [], // Use an empty array if there’s no data for 'batch'
  }

  // const materialDetailsTable1 = () => {
  //   return (
  //     (displayData?.orderDetails?.[0]?.items?.length || isProcessingRecord) && (
  //       <table
  //         style={
  //           {
  //             // fontFamily: 'Inter, Arial, sans-serif',
  //           }
  //         }
  //         className='table table-hover table-rounded  border gy-4 gs-7 '
  //       >
  //         <thead>
  //           <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
  //             <th style={{ minWidth: '50px' }}>S.N</th>
  //             {
  //               <>
  //                 <th style={{ maxWidth: isProcessingRecord ? '-1px' : '1px' }}>
  //                   {isProcessingRecord ? 'Input' : 'Batch id'}
  //                 </th>
  //               </>
  //             }
  //             {!isProcessingRecord && <th style={{}}>Category</th>}
  //             <th style={{}}>
  //               {changeInProcessingRecord
  //                 ? 'Process'
  //                 : isProcessingRecord
  //                   ? 'Diversion Type'
  //                   : !isReturnOrdersPage
  //                     ? 'Item'
  //                     : 'Item'}
  //             </th>

  //             {location.pathname === '/apps/transactions/items' && <th style={{}}>
  //               Rate
  //             </th>}

  //             <th style={{}}>
  //               {location.pathname === '/apps/transactions/supply-orders' ? 'Supplied' : 'Quantity'}
  //             </th>

  //             {location.pathname === '/apps/transactions/items' && <th style={{}}>
  //               Amount
  //             </th>}

  //             {(isProcessingRecord && (
  //               <>
  //                 <th>Output</th>
  //                 <th>Quantity</th>
  //               </>
  //             )) ||
  //               ''}
  //             {isCollectOrders && <th style={{}}>Unit price </th>}
  //             {isCollectOrders && <th style={{}}>Total</th>}
  //             {location.pathname === '/apps/transactions/supply-orders' && (
  //               <th style={{}}>Rate</th>
  //             )}
  //             {location.pathname === '/apps/transactions/supply-orders' && (
  //               <th style={{}}>Amount</th>
  //             )}
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {isProcessingRecord
  //             ? displayData?.inputMaterial?.map((eachData, eachInd) => (
  //               <tr key={eachInd + 1 + '-'} className='text-center'>
  //                 <td>{eachInd + 1 + ''}</td>
  //                 <td> {eachData?.inputMaterialName} </td>
  //                 <td>{displayData?.processName}</td>
  //                 <td>{parseFloat(eachData?.inputQuantity)?.toFixed(2) ?? ''}</td>
  //                 <td>{displayData?.productionItemDetails?.[eachInd]?.itemName ?? ''}</td>
  //                 <td>{displayData?.productionItemDetails?.[eachInd]?.quantity ?? ''}</td>
  //               </tr>
  //             ))
  //             : displayData?.orderDetails?.[0]?.items?.map((eachData, eachInd) => (
  //               <tr key={eachInd + 1 + '-'} className='text-center'>
  //                 <td>{eachInd + 1 + ''}</td>
  //                 <td> {displayData?.createdAt} </td>
  //                 <td>{displayData?.orderDetails?.[0]?.categoryName}</td>
  //                 <td>{eachData.itemName}</td>

  //                 {location.pathname === '/apps/transactions/items' && <td>{eachData.price}</td>}

  //                 <td>
  //                   {eachData.quantity?.toFixed(2)} {eachData.unit}
  //                 </td>

  //                 {location.pathname === '/apps/transactions/items' && <td>{(eachData.price * eachData.quantity)?.toFixed(2)}</td>}

  //                 {isCollectOrders && <td>{eachData.price}</td>}
  //                 {isCollectOrders && <td>{(eachData.quantity * eachData.price).toFixed(2)}</td>}
  //                 {location.pathname === '/apps/transactions/supply-orders' && (
  //                   <td>
  //                     {displayData?.orderDetails?.[0]?.items?.[0]?.price}
  //                   </td>
  //                 )}
  //                 {location.pathname === '/apps/transactions/supply-orders' && (
  //                   <td>
  //                     {(eachData.quantity * displayData?.orderDetails?.[0]?.items?.[0]?.price)?.toFixed(2)}
  //                   </td>
  //                 )}
  //               </tr>
  //             ))}
  //         </tbody>
  //         <tfoot>
  //           {location.pathname === '/apps/transactions/collect-orders' && (
  //             <tr>
  //               <td colSpan={4} className='text-end fw-bold' style={{ fontSize: '18px' }}>
  //                 Total
  //               </td>
  //               <td className='text-center fw-bold'>
  //                 {displayData?.orderDetails?.[0]?.items
  //                   ?.reduce((sum, item) => sum + (item.quantity || 0), 0)
  //                   ?.toFixed(2)} kg
  //               </td>
  //               <td className='text-end fw-bold' style={{ fontSize: '18px' }}>

  //               </td>
  //               <td className='text-center fw-bold'>
  //                 {displayData?.orderDetails?.[0]?.items
  //                   ?.reduce((sum, item) => sum + (item.quantity * item.price || 0), 0)
  //                   ?.toFixed(2)}
  //               </td>
  //             </tr>
  //           )}

  //           {displayData.weightScaleCaliber && (
  //             <tr>
  //               <td colSpan={isProcessingRecord ? 3 : isReturnOrdersPage ? 4 : 4}></td>
  //               <td className='text-center fw-bold ' style={{ float: 'right' }}>
  //                 {/* <img
  //         width={60}
  //         height={60}
  //         style={{
  //           backgroundColor: '#FFFFFF',
  //           marginTop: '-55px',
  //           marginRight: '-28px',
  //         }}
  //         // src={toAbsoluteUrl('/media/misc/Verified.png')}
  //         alt='main-logo'
  //       /> */}
  //               </td>
  //             </tr>
  //           )}
  //         </tfoot>
  //       </table>
  //     )
  //   )
  // }

  const materialDetailsTable = () => {
    return (
      (displayData?.orderDetails?.[0]?.items?.length || isProcessingRecord) && (
        <div
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            marginBottom: '16px',
          }}
        >
          <div
            style={{
              backgroundColor: '#e6f0f3',
              color: '#0a3d62',
              fontSize: '18px',
              fontWeight: 'bold',
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>Material details</span>

            {displayData?.specialCharacteristics && displayData.specialCharacteristics.length > 0 && (
              <div style={{display: 'flex', gap: '8px'}}>
                {displayData.specialCharacteristics.map((characteristic, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: '#d0bdf9',
                      color: '#7239ea',
                      padding: '4px 8px',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    {characteristic.replace(/_/g, ' ')}
                  </div>
                ))}
              </div>
            )}
          </div>
          <table className='table table-hover table-rounded border gy-4 gs-7'>
            <thead>
              <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                <th style={{minWidth: '50px'}}>S.N</th>
                {
                  <>
                    <th style={{maxWidth: isProcessingRecord ? '-1px' : '1px'}}>
                      {isProcessingRecord ? 'Input' : 'Batch id'}
                    </th>
                  </>
                }
                {!isProcessingRecord && <th style={{}}>Category</th>}
                <th style={{}}>
                  {changeInProcessingRecord
                    ? 'Process'
                    : isProcessingRecord
                    ? 'Diversion Type'
                    : !isReturnOrdersPage
                    ? 'Item'
                    : 'Item'}
                </th>

                {location.pathname === '/apps/transactions/items' && <th style={{}}>Rate</th>}

                <th style={{}}>
                  {location.pathname === '/apps/transactions/supply-orders'
                    ? 'Supplied'
                    : 'Quantity'}
                </th>

                {location.pathname === '/apps/transactions/items' && <th style={{}}>Amount</th>}

                {(isProcessingRecord && (
                  <>
                    <th>Output</th>
                    <th>Quantity</th>
                  </>
                )) ||
                  ''}
                {isCollectOrders && <th style={{}}>Unit price </th>}
                {isCollectOrders && <th style={{}}>Total</th>}
                {location.pathname === '/apps/transactions/supply-orders' && (
                  <th style={{}}>Rate</th>
                )}
                {location.pathname === '/apps/transactions/supply-orders' && (
                  <th style={{}}>Amount</th>
                )}
              </tr>
            </thead>
            <tbody>
              {isProcessingRecord
                ? displayData?.inputMaterial?.map((eachData, eachInd) => (
                    <tr key={eachInd + 1 + '-'} className='text-center'>
                      <td>{eachInd + 1 + ''}</td>
                      <td> {eachData?.inputMaterialName} </td>
                      <td>{displayData?.processName}</td>
                      <td>{parseFloat(eachData?.inputQuantity)?.toFixed(2) ?? ''}</td>
                      <td>{displayData?.productionItemDetails?.[eachInd]?.itemName ?? ''}</td>
                      <td>{displayData?.productionItemDetails?.[eachInd]?.quantity ?? ''}</td>
                    </tr>
                  ))
                : displayData?.orderDetails
                    ?.flatMap((eachOrder) =>
                      (eachOrder?.items || []).map((item) => ({item: item, order: eachOrder}))
                    )
                    ?.map(({item: eachData, order}, eachInd) => (
                      <tr key={eachInd + 1 + '-'} className='text-center'>
                        <td>{eachInd + 1 + ''}</td>
                        <td> {displayData?.createdAt} </td>
                        <td>{order?.categoryName}</td>
                        <td>{eachData.itemName}</td>

                        {location.pathname === '/apps/transactions/items' && (
                          <td>{eachData.price}</td>
                        )}

                        {location.pathname === '/apps/transactions/supply-orders' ? (
                          <td>
                            {eachData.quantity} {eachData.unit}
                          </td>
                        ) : (
                          <td>
                            {(
                              eachData.quantity -
                              (displayData?.transportationLoss?.[0]?.items?.filter(
                                (tranportItem) => tranportItem?.itemId === eachData?.itemId
                              )?.[0]?.quantity || 0)
                            )?.toFixed(2)}{' '}
                            {eachData.unit}
                          </td>
                        )}

                        {location.pathname === '/apps/transactions/items' && (
                          <td>{(eachData.price * eachData.quantity)?.toFixed(2)}</td>
                        )}

                        {isCollectOrders && <td>{eachData.price}</td>}
                        {isCollectOrders && (
                          <td>{(eachData.quantity * eachData.price).toFixed(2)}</td>
                        )}
                        {location.pathname === '/apps/transactions/supply-orders' && (
                          <td>{order?.items?.[0]?.price}</td>
                        )}
                        {location.pathname === '/apps/transactions/supply-orders' && (
                          <td>
                            {(eachData.quantity * (order?.items?.[0]?.price || 0))?.toFixed(2)}
                          </td>
                        )}
                      </tr>
                    ))}
            </tbody>
            <tfoot>
              {location.pathname === '/apps/transactions/collect-orders' && (
                <tr>
                  <td colSpan={4} className='text-end fw-bold' style={{fontSize: '18px'}}>
                    Total
                  </td>
                  <td className='text-center fw-bold'>
                    {displayData?.orderDetails
                      ?.flatMap((order) => order?.items || [])
                      ?.reduce((sum, item) => sum + (item.quantity || 0), 0)
                      ?.toFixed(2)}{' '}
                    kg
                  </td>
                  <td className='text-end fw-bold' style={{fontSize: '18px'}}></td>
                  <td className='text-center fw-bold'>
                    {displayData?.orderDetails
                      ?.flatMap((order) => order?.items || [])
                      ?.reduce((sum, item) => sum + (item.quantity || 0) * (item.price || 0), 0)
                      ?.toFixed(2)}
                  </td>
                </tr>
              )}

              {displayData.weightScaleCaliber && (
                <tr>
                  <td colSpan={isProcessingRecord ? 3 : isReturnOrdersPage ? 4 : 4}></td>
                  <td className='text-center fw-bold ' style={{float: 'right'}}></td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      )
    )
  }

  const renderDataRecursively = (items, key) => {
    if (!items || items.length === 0) return null

    return items.map((item, index) => (
      <div key={`${key}-${index}`} style={{marginLeft: index > 0 ? '20px' : '0px'}}>
        {/* Render Table */}
        <table className='table table-hover table-rounded border table-row-dashed gy-4 gs-7'>
          <tbody>
            {mapList[key]?.map(({value, label}, rowIndex) => (
              <tr key={rowIndex} className='text-center cell'>
                <td>{label}</td>
                <td>
                  {label === 'Date'
                    ? item?.[value]
                      ? new Date(item[value] || new Date()).toLocaleDateString()
                      : '-'
                    : item?.[value] ?? '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Render Images */}
        {item?.images?.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              marginBottom: '22px',
            }}
          >
            {item.images.map((img, imgIndex) => (
              <div
                key={imgIndex}
                className='image-input'
                style={{
                  width: '48%',
                  marginBottom: '20px',
                }}
              >
                <div
                  onClick={() => handleClick(img)}
                  className='image-input-wrapper'
                  style={{
                    width: '100%',
                    paddingBottom: '100%',
                    backgroundImage: `url(${img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '8px',
                  }}
                ></div>
              </div>
            ))}
          </div>
        )}
        {/* Recursive Rendering for Nested Data */}
        {item.collectionDetails && renderDataRecursively(item.collectionDetails, key)}
        {item.processDetails && renderDataRecursively(item.processDetails, 'production')}{' '}
        {/* Assuming `production` key for processDetails */}
      </div>
    ))
  }

  return (
    <>
      {window.location.pathname === '/apps/transactions/processing-record' && false ? (
        <div>
          <div
            ref={certificateRef}
            style={{
              position: 'relative',
              padding: '20px',
              width: '100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top left, bottom right, center',
              backgroundSize: 'auto, auto, cover',
              fontFamily: 'Inter, Arial, sans-serif',
            }}
          >
            {window.location.pathname === '/apps/transactions/processing-record' && (
              <img
                src='/BGImg.png'
                alt='background'
                onLoad={() => console.log('✅ Image loaded')}
                onError={() => console.log('❌ Image failed')}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'fill',
                  opacity: 1,
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              />
            )}

            <div
              id='pdf-content'
              className='container'
              style={{
                position: 'relative',
                zIndex: 2,
              }}
            >
              <div className='row'>
                <div
                  className='col-9'
                  style={{
                    fontSize: '32px',
                    fontStyle: 'italic',
                    fontWeight: 'bold',
                    lineHeight: '40px',
                    padding: '21px 40px',
                  }}
                >
                  <div>
                    {isSupplyOrders
                      ? `${
                          pathname.includes('apps/transactions/items') ? 'Sale' : 'Dispatch'
                        } receipt`
                      : changeInProcessingRecord
                      ? 'Production receipt'
                      : isProcessingRecord
                      ? 'Diversion Certificate'
                      : ' Collection receipt'}
                  </div>
                  <div></div>
                  <hr style={lineStyle} />
                </div>

                <div className='col-3'>
                  <img
                    src={displayData?.kycDocuments?.docUrl}
                    alt=''
                    style={{
                      borderRadius: '50%',
                      width: '60px', // made smaller (was 100px)
                      height: '60px', // made smaller (was 100px)
                      objectFit: 'cover',
                      transform: 'translateX(100px)',
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  fontFamily: 'Inter, Arial, sans-serif',
                  padding: '10px 20px',
                }}
              >
                <p
                  style={{
                    fontSize: '1.075rem',
                    transform: 'translateY(-32px) translateX(10px)',
                    // border: "2px solid black",
                    marginBottom: '-32px',
                  }}
                >
                  Date :{' '}
                  {displayData?.createdAt
                    ? new Date(displayData.createdAt).toISOString().split('T')[0]
                    : '-'}
                </p>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    margin: '0',
                    padding: '0',
                    minHeight: '40px', // Reserve space for the certification row
                  }}
                >
                  {displayData?.certifications?.length > 0 &&
                    displayData.certifications.map((certification, index) => (
                      <div
                        key={certification.id || index}
                        title={certification.certificationName}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          overflow: 'hidden',
                          border: '2px solid #e9ecef',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#ffffff',
                          cursor: 'pointer',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                        onClick={() => handleClick(certification.logo)}
                      >
                        <img
                          src={certification.logo}
                          alt={certification.certificationName}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      </div>
                    ))}
                </div>

                <div
                  // className='text-center'
                  style={{
                    marginTop: '-5px',
                    color: '#242727',
                    fontSize: '18px',
                    fontWeight: 'bold',
                  }}
                >
                  {changeInProcessingRecord
                    ? 'Facility information'
                    : isProcessingRecord
                    ? 'Diversion Facility'
                    : isReturnOrdersPage
                    ? 'Supplying facility'
                    : ' Source of waste'}
                </div>

                <hr style={lineStyle} />

                <div className='row'>
                  <div className='col-9'>
                    <div className='row'>
                      <div className='col-12'>
                        {(isProcessingRecord
                          ? diverisonName
                          : isReturnOrdersPage
                          ? collectionData
                          : depositerName
                        ).map((eachData, ind) => (
                          <div className='row' key={ind + 1 + ''} style={{fontSize: '14px'}}>
                            <label
                              className='col-lg-4 '
                              style={{color: '#242727', fontWeight: '700'}}
                            >
                              {eachData.label}
                            </label>
                            <div className='col-lg-8' style={{color: '#4F5152'}}>
                              <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {!shouldShowMaterialDetails && (
                    <div
                      style={{
                        marginTop: '20px',
                        marginBottom: '-7px',
                        fontSize: '18px',
                        fontWeight: 'bold',
                      }}
                    >
                      Material details
                    </div>
                  )}

                  {shouldShowMaterialDetails && (
                    <div className='p-6 max-w-4xl mx-auto'>
                      <div className='flex items-center justify-between gap-6'>
                        {/* Left side - Material details header */}
                        <div
                          style={{
                            marginTop: '20px',
                            marginBottom: '-7px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                          }}
                        >
                          Material details
                        </div>

                        {/* Right side - Dynamic special characteristics */}
                      </div>
                    </div>
                  )}

                  {shouldShowMaterialDetails &&
                    displayData?.specialCharacteristics &&
                    displayData.specialCharacteristics.length > 0 && (
                      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        {displayData.specialCharacteristics.map((characteristic, index) => (
                          <div
                            key={index}
                            className='px-1 py-0.5 border border-gray-300 rounded-lg text-xs font-bold'
                            style={{
                              backgroundColor: '#d0bdf9',
                              color: '#7239ea',
                              marginLeft: '8px',
                            }}
                          >
                            {characteristic.replace(/_/g, ' ')}
                          </div>
                        ))}
                      </div>
                    )}

                  {/* {materialDetailsTable()} */}
                  <div style={{width: '500px'}}>
                    {location.pathname !== '/apps/transactions/processing-record' &&
                      materialDetailsTable()}
                  </div>

                  {location.pathname === '/apps/transactions/processing-record' && (
                    <table className='table table-hover table-rounded border gy-4 gs-7'>
                      <thead>
                        <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                          <th style={{maxWidth: '1px'}}>SL</th>
                          <th>Type</th>
                          <th>Category</th>
                          <th>Item</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(displayData?.inputMaterial || []).map((row, index) => (
                          <tr key={index} className='text-center'>
                            <td>{index + 1}</td>
                            <td>Input Material</td>
                            <td>{row.inputMaterialCategoryName || '-'}</td>
                            <td>{row.inputMaterialName || '-'}</td>
                            <td>{parseFloat(row.inputQuantity || 0).toFixed(2)} kg</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  {location.pathname === '/apps/transactions/processing-record' && (
                    <>
                      <div
                        style={{
                          marginTop: '20px',
                          marginBottom: '-7px',
                          fontSize: '18px',
                          fontWeight: 'bold',
                        }}
                      >
                        <span>
                          Process name:{' '}
                          <span
                            style={{
                              backgroundColor: '#d0bdf9',
                              color: '#7239ea',
                              borderRadius: '6px',
                              padding: '2px 6px',
                              fontSize: '12px',
                            }}
                          >
                            {displayData?.processName}
                          </span>
                        </span>
                      </div>
                      <table className='table table-hover table-rounded border gy-4 gs-7'>
                        <thead>
                          <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                            <th style={{maxWidth: '1px'}}>SL</th>
                            <th>Type</th>
                            <th>Category</th>
                            <th>Item</th>
                            <th>Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(displayData?.productionItemDetails || []).map((row, index) => (
                            <tr key={index} className='text-center'>
                              <td>{index + 1}</td>
                              <td>Output Material</td>
                              <td>{row.categoryName || '-'}</td>
                              <td>{row.itemName || '-'}</td>
                              <td>{row.quantity || '-'} kg</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}

                  {(location.pathname === '/apps/transactions/collect-orders' ||
                    location.pathname === '/apps/transactions/items') && (
                    <div
                      style={{
                        padding: '16px',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef',
                        marginBottom: '12px',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '14px',
                          color: '#6c757d',
                          marginBottom: '8px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Remarks
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#212529',
                          lineHeight: '1.5',
                        }}
                      >
                        {displayData?.remarks || 'No remarks available'}
                      </div>
                    </div>
                  )}

                  {(isReturnOrdersPage && (
                    <>
                      <div className='row'>
                        <div className='col-15'>
                          <div className=''>
                            <div
                              className=''
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                width: 'fit-content',
                                marginTop: '20px',
                              }}
                            >
                              {' '}
                              {location.pathname === '/apps/transactions/items'
                                ? 'Customer Information'
                                : ' Receiving facility'}
                            </div>

                            {/* {receivingFacility?.map((eachData, ind) => (
                          <div className='row' key={ind + 1 + ''} style={{ fontSize: '14px' }}>
                            <label
                              className='col-lg-3'
                              style={{ color: '#242727', fontWeight: '700' }}
                            >
                              {eachData.label}
                            </label>
                            <div className='col-9' style={{ color: '#4F5152' }}>
                              <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                            </div>
                          </div>
                        ))} */}

                            {receivingFacility?.map((eachData, ind) => (
                              <div
                                className='row'
                                key={ind + 1 + ''}
                                style={{
                                  fontSize: '14px',
                                  display: 'table',
                                  width: '100%',
                                  tableLayout: 'fixed',
                                }}
                              >
                                <label
                                  className='col-lg-3'
                                  style={{
                                    color: '#242727',
                                    fontWeight: '700',
                                    display: 'table-cell',
                                    width: '25%',
                                    verticalAlign: 'top',
                                  }}
                                >
                                  {eachData.label}
                                </label>
                                <div
                                  className='col-9'
                                  style={{
                                    color: '#4F5152',
                                    display: 'table-cell',
                                    width: '75%',
                                    verticalAlign: 'top',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {location.pathname === '/apps/transactions/supply-orders' && (
                          <div
                            style={{
                              position: 'relative',
                              width: '160%',
                              height: '150px',
                              margin: '0 auto',
                            }}
                          >
                            <div
                              style={{
                                width: '140px',
                                height: '80px',
                                backgroundColor: 'white',
                                color: 'black',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'absolute',
                                left: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                borderRadius: '5px',
                                padding: '12px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                              }}
                            >
                              {displayData.pickupPointName}
                            </div>

                            <div
                              style={{
                                width: '140px',
                                height: '80px',
                                backgroundColor: 'white',
                                color: 'black',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'absolute',
                                right: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                borderRadius: '5px',
                                padding: '12px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                              }}
                            >
                              {displayData?.toPickupPointName}
                            </div>

                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '140px',
                                right: '140px',
                                height: '2px',
                                backgroundColor: 'black',
                                transform: 'translateY(-50%)',
                              }}
                            />

                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -150%)',
                                backgroundColor: 'white',
                                padding: '4px 8px',
                                fontWeight: 'bold',
                                boxShadow: '0 0 3px rgba(0,0,0,0.1)',
                              }}
                            >
                              {displayData.routeLength}, {displayData.transportType}
                            </div>
                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, 50%)',
                                backgroundColor: 'white',
                                padding: '4px 8px',
                                fontWeight: 'bold',
                                boxShadow: '0 0 3px rgba(0,0,0,0.1)',
                              }}
                            >
                              {displayData.status === 'Created'
                                ? 'In transit'
                                : displayData.status === 'Completed'
                                ? 'Delivered'
                                : displayData.status}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )) || (
                    <div className='row'>
                      <div className='row'>
                        {(pathname.includes('apps/transactions/processing-record') && (
                          <div className='col-9'>
                            <div className='row' style={{fontSize: '14px', marginBottom: '20px'}}>
                              <label
                                className='col-lg-4'
                                style={{color: '#242727', fontWeight: '700'}}
                              >
                                Process loss
                              </label>
                              <div className='col-lg-8' style={{color: '#4F5152'}}>
                                {/* <span className='fs-6'>
                                : &nbsp;&nbsp;{displayData.wastage + '' || ''}
                              </span> */}
                                <span className='fs-6'>
                                  : &nbsp;&nbsp;
                                  <span
                                    style={{
                                      backgroundColor: '#fdb3c6',
                                      color: '#f7285a',
                                      borderRadius: '6px',
                                      padding: '2px 6px',
                                      fontSize: '12px',
                                    }}
                                  >
                                    {parseFloat(displayData.wastage || 0).toFixed(2)}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        )) ||
                          ''}
                      </div>
                      <div className='col-12'>
                        <div
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                          }}
                        >
                          {' '}
                          {changeInProcessingRecord
                            ? 'Production information'
                            : isProcessingRecord
                            ? 'Diversion Information'
                            : 'Facility information'}
                        </div>
                        <hr style={lineStyle} />
                        <div className='row'>
                          <div className='col-12'>
                            {/* {(isProcessingRecord ? diversionInformation : collectorDetails).map(
                            (eachData, ind) => (
                              <div className='row' key={ind + 1 + ''} style={{ fontSize: '14px' }}>
                                <label
                                  className='col-lg-3'
                                  style={{ color: '#242727', fontWeight: '700' }}
                                >
                                  {eachData.label}
                                </label>
                                <div className='col-lg-9' style={{ color: '#4F5152' }}>
                                  <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                                </div>
                              </div>
                            )
                          )} */}
                            {(isProcessingRecord ? diversionInformation : collectorDetails).map(
                              (eachData, ind) => (
                                <div
                                  className='row'
                                  key={ind + 1 + ''}
                                  style={{
                                    fontSize: '14px',
                                    display: 'table',
                                    width: '100%',
                                    tableLayout: 'fixed',
                                  }}
                                >
                                  <label
                                    className='col-lg-3'
                                    style={{
                                      color: '#242727',
                                      fontWeight: '700',
                                      display: 'table-cell',
                                      width: '25%',
                                      verticalAlign: 'top',
                                    }}
                                  >
                                    {eachData.label}
                                  </label>
                                  <div
                                    className='col-lg-9'
                                    style={{
                                      color: '#4F5152',
                                      display: 'table-cell',
                                      width: '75%',
                                      verticalAlign: 'top',
                                      wordWrap: 'break-word',
                                    }}
                                  >
                                    <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                          <div className='col-3'>
                            {isAudited ? (
                              <img
                                style={{backgroundColor: '#FFFFFF', marginTop: '1px'}}
                                src={toAbsoluteUrl('/media/misc/audilogo.png')}
                                alt='main-logo'
                              />
                            ) : (
                              <>
                                {/* {location.pathname !== '/apps/transactions/collect-orders' && (
                                <>
                                  <div
                                    style={{
                                      fontFamily: 'Best Signature Font',
                                      fontSize: '22px',
                                      marginTop: '-6px',
                                    }}
                                  >
                                    {displayData.createdByName}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    Signature
                                  </div>
                                </>
                              )} */}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className='row'>
                <div className='col-12'>
                  <div
                    style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      marginTop: '18px',
                      //  fontFamily: 'Inter, Arial, sans-serif',
                    }}
                  >
                    Calibration
                  </div>
                  <hr style={lineStyle} />
                  <div className='row'>
                    <div className='col-9'>
                      {calibrationCertifications?.map((eachData, ind) => (
                        <div className='row' key={ind + 1 + ''} style={{ fontSize: '14px' }}>
                          <label className='col-lg-4' style={{ color: '#242727', fontWeight: '700' }}>
                            {eachData.label}
                          </label>
                          <div className='col-lg-8' style={{ color: '#4F5152' }}>
                            <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                          </div>
                        </div>
                      )) || ''}
                    </div>
                  </div>
                </div>
              </div> */}

                  {/* {location.pathname !== '/apps/transactions/processing-record' &&
                location.pathname !== '/apps/transactions/collect-orders' &&
                location.pathname !== '/apps/transactions/items' && (
                  <div className='row'>
                    <div className='col-12'>
                      <div
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginTop: '18px',
                        
                        }}
                      >
                        Calibration
                      </div>
                      <hr style={lineStyle} />
                      <div className='row'>
                        <div className='col-9'>
                          {calibrationCertifications?.map((eachData, ind) => (
                            <div className='row' key={ind + 1 + ''} style={{ fontSize: '14px' }}>
                              <label className='col-lg-4' style={{ color: '#242727', fontWeight: '700' }}>
                                {eachData.label}
                              </label>
                              <div className='col-lg-8' style={{ color: '#4F5152' }}>
                                <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                              </div>
                            </div>
                          )) || ''}
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

                  {isProcessingRecord && (
                    <div className='row'>
                      <div className='col-12'>
                        <div
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginTop: '18px',
                            //  fontFamily: 'Inter, Arial, sans-serif',
                          }}
                        >
                          Chain of custody
                        </div>
                        <hr style={lineStyle} />
                        <div className='row'>
                          {displayData.images?.map((eachData, ind) => (
                            <div className='col-lg-4'>
                              <img
                                width='100px'
                                height='100px'
                                src={eachData || ''}
                                alt='main-logo'
                              />
                            </div>
                          )) || ''}
                        </div>
                      </div>
                    </div>
                  )}

                  {(!isSupplyOrders && !isCollectOrders && displayData?.certifications?.length && (
                    <>
                      {location.pathname !== '/apps/transactions/processing-record' && (
                        <>
                          <div
                            style={{
                              fontSize: '18px',
                              marginTop: '18px',
                              fontWeight: 'bold',
                            }}
                          >
                            Certifications
                          </div>
                          <table className='table table-hover table-rounded  border gy-4 gs-7 '>
                            <thead /* style={{background: '#1C4379'}} */>
                              <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                                <th style={{minWidth: '4px'}}>S.N</th>
                                <th>Certificate name</th>
                                <th>Number</th>
                                <th>Issued by</th>
                                <th>Issued on</th>
                              </tr>
                            </thead>
                            <tbody>
                              {displayData?.certifications?.map((eachCertification, eachInd) => (
                                <tr key={eachInd + 1 + ''} className='text-center'>
                                  <td>{eachInd + 1 + ''}</td>
                                  <td>{eachCertification.certificationName}</td>
                                  <td>{eachCertification.certificationNo}</td>
                                  <td>{eachCertification.issuingAuthorities}</td>
                                  <td>
                                    {eachCertification.issuedOn
                                      ? new Date(eachCertification.issuedOn).toLocaleDateString()
                                      : '-'}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      )}
                    </>
                  )) ||
                    ''}
                  {isAudited && (
                    <>
                      <div className='row'>
                        <div className='col-12'>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 'bold',
                              //  fontFamily: 'Inter, Arial, sans-serif',
                            }}
                          >
                            {' '}
                            Auditor Information
                          </div>
                          <hr style={lineStyle} />
                          <div className='row'>
                            <div className='col-9'>
                              {auditorInformation.map((eachData, ind) => (
                                <div className='row' key={ind + 1 + ''} style={{fontSize: '14px'}}>
                                  <label
                                    className='col-lg-4'
                                    style={{color: '#242727', fontWeight: '700'}}
                                  >
                                    {eachData.label}
                                  </label>
                                  <div className='col-lg-8' style={{color: '#4F5152'}}>
                                    <span className='fs-6'>: &nbsp;&nbsp;{eachData.value}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className='col-3'>
                              <div className=''>
                                <img
                                  width='100px'
                                  height='100px'
                                  src={displayData.sign || ''}
                                  alt='main-logo'
                                />
                              </div>
                              <div
                                style={{
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                }}
                              >
                                Signature
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {!changeInProcessingRecord && (
                    <div>
                      <br />
                      <div
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                        }}
                      >
                        Chain of custody
                      </div>
                      <hr style={lineStyle} />
                      <br />
                      {isProcessingRecord ? (
                        <>
                          {Object.keys(mapList).map((x) => (
                            <>
                              <div
                                style={{
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                }}
                              >
                                {capitalizeWords(x)}
                                <hr />
                                Supply chain Traceability
                              </div>
                              <hr style={lineStyle} />
                              <br />
                              {x === 'proofOfDiversion' && materialDetailsTable()}
                              {renderDataRecursively(dataMap[x], x)}
                            </>
                          ))}
                        </>
                      ) : (
                        ''
                      )}
                      {displayData?.images?.length ? (
                        <div
                          style={
                            !isProcessingRecord
                              ? {
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  marginBottom: '22px',
                                }
                              : {
                                  display: 'flex',
                                  flexWrap: 'wrap', // Allow wrapping to the next row
                                  justifyContent: 'space-between', // Evenly distribute space between images
                                  marginBottom: '22px',
                                }
                          }
                        >
                          {/* {displayData.images.map((eachImages, eachInd) => (
                        <div
                          key={eachInd + 1}
                          className='image-input'
                          style={!isProcessingRecord ? {} : { width: '48%', marginBottom: '20px' }}
                        >
                          <div
                            onClick={() => handleClick(eachImages)}
                            className='image-input-wrapper'
                            style={
                              !isProcessingRecord
                                ? {
                                  width: 163,
                                  height: 150,
                                  // backgroundSize: '400px',
                                  marginRight: '15px',
                                  // backgroundImage: `url(${eachImages})`,
                                  backgroundImage: `url(${eachImages})`,
                                }
                                : {
                                  width: '100%', // Full width of the container (48% of the row)
                                  paddingBottom: '100%', // Maintain aspect ratio (square)
                                  backgroundImage: `url(${eachImages})`,
                                  backgroundSize: 'cover', // Ensure image covers the div
                                  backgroundPosition: 'center', // Center the image
                                  backgroundRepeat: 'no-repeat', // Avoid repeating the image
                                  borderRadius: '8px', // Optional: add rounded corners
                                }
                            }
                          ></div>
                        </div>
                      ))} */}

                          {displayData.images.slice(0, 3).map((eachImages, eachInd) => (
                            <div
                              key={eachInd + 1}
                              className='image-input'
                              style={
                                !isProcessingRecord ? {} : {width: '48%', marginBottom: '20px'}
                              }
                            >
                              <div
                                onClick={() => handleClick(eachImages)}
                                className='image-input-wrapper'
                                style={
                                  !isProcessingRecord
                                    ? {
                                        width: 163,
                                        height: 150,
                                        // backgroundSize: '400px',
                                        marginRight: '15px',
                                        // backgroundImage: `url(${eachImages})`,
                                        backgroundImage: `url(${eachImages})`,
                                      }
                                    : {
                                        width: '100%', // Full width of the container (48% of the row)
                                        paddingBottom: '100%', // Maintain aspect ratio (square)
                                        backgroundImage: `url(${eachImages})`,
                                        backgroundSize: 'cover', // Ensure image covers the div
                                        backgroundPosition: 'center', // Center the image
                                        backgroundRepeat: 'no-repeat', // Avoid repeating the image
                                        borderRadius: '8px', // Optional: add rounded corners
                                      }
                                }
                              />
                            </div>
                          ))}

                          {location.pathname === '/apps/transactions/items' &&
                            displayData.orderConfirmedImages &&
                            displayData.orderConfirmedImages.map((fileUrl, fileInd) => (
                              <div
                                key={`file-${fileInd}`}
                                className='file-input'
                                style={
                                  !isProcessingRecord ? {} : {width: '48%', marginBottom: '20px'}
                                }
                              >
                                <img
                                  src={fileUrl}
                                  alt='Order confirmation'
                                  style={{display: 'none'}}
                                  onLoad={(e) => {
                                    // If image loads successfully, show it as an image
                                    const container = (e.target as HTMLImageElement).parentElement
                                    const imageDiv = container?.querySelector(
                                      '.image-display'
                                    ) as HTMLElement
                                    const pdfDiv = container?.querySelector(
                                      '.pdf-display'
                                    ) as HTMLElement
                                    if (imageDiv && pdfDiv) {
                                      imageDiv.style.display = 'block'
                                      pdfDiv.style.display = 'none'
                                    }
                                  }}
                                  onError={(e) => {
                                    // If image fails to load, show it as a PDF
                                    const container = (e.target as HTMLImageElement).parentElement
                                    const imageDiv = container?.querySelector(
                                      '.image-display'
                                    ) as HTMLElement
                                    const pdfDiv = container?.querySelector(
                                      '.pdf-display'
                                    ) as HTMLElement
                                    if (imageDiv && pdfDiv) {
                                      imageDiv.style.display = 'none'
                                      pdfDiv.style.display = 'block'
                                    }
                                  }}
                                />

                                {/* Image display */}
                                <div
                                  className='image-display'
                                  onClick={() => handleClick(fileUrl)}
                                  style={{
                                    display: 'none',
                                    cursor: 'pointer',
                                    ...(!isProcessingRecord
                                      ? {
                                          width: 163,
                                          height: 150,
                                          marginRight: '15px',
                                          backgroundImage: `url(${fileUrl})`,
                                          backgroundSize: 'cover',
                                          backgroundPosition: 'center',
                                          backgroundRepeat: 'no-repeat',
                                          borderRadius: '8px',
                                        }
                                      : {
                                          width: '100%',
                                          paddingBottom: '100%',
                                          backgroundImage: `url(${fileUrl})`,
                                          backgroundSize: 'cover',
                                          backgroundPosition: 'center',
                                          backgroundRepeat: 'no-repeat',
                                          borderRadius: '8px',
                                        }),
                                  }}
                                />

                                {/* PDF display */}
                                {/* PDF display */}
                                <div
                                  className='pdf-display'
                                  onClick={() => window.open(fileUrl, '_blank')}
                                  style={{
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    ...(!isProcessingRecord
                                      ? {
                                          width: 163,
                                          height: 150,
                                          lineHeight: '150px',
                                          marginRight: '15px',
                                          backgroundColor: '#f8f9fa',
                                          border: '2px solid #dee2e6',
                                          borderRadius: '8px',
                                        }
                                      : {
                                          width: '100%',
                                          paddingBottom: '100%',
                                          backgroundColor: '#f8f9fa',
                                          border: '2px solid #dee2e6',
                                          borderRadius: '8px',
                                          position: 'relative',
                                        }),
                                  }}
                                >
                                  {!isProcessingRecord ? (
                                    <i
                                      className='fas fa-file-pdf'
                                      style={{
                                        fontSize: '60px',
                                        color: '#dc3545',
                                        verticalAlign: 'middle',
                                      }}
                                    ></i>
                                  ) : (
                                    <i
                                      className='fas fa-file-pdf'
                                      style={{
                                        fontSize: '60px',
                                        color: '#dc3545',
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        lineHeight: '1',
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ))}

                          {/* Empty placeholders for remaining image slots */}
                          {Array.from({length: 3 - Math.min(displayData.images.length, 3)}).map(
                            (_, index) => (
                              <div
                                key={`placeholder-${index}`}
                                className='image-input'
                                style={
                                  !isProcessingRecord
                                    ? {width: 163, height: 150, marginRight: '15px'}
                                    : {width: '48%', marginBottom: '20px'}
                                }
                              />
                            )
                          )}

                          {/* Signature section - only for collect-orders path */}

                          <div
                            style={{
                              display: 'inline-block',
                              verticalAlign: 'top',
                              marginLeft: '15px',
                            }}
                          >
                            <div
                              style={{
                                fontFamily: 'Best Signature Font',
                                fontSize: '22px',
                                marginTop: '-6px',
                              }}
                            >
                              {displayData.createdByName}
                            </div>
                            <div
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                              }}
                            >
                              Signature
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}

                  {!changeInProcessingRecord && isProcessingRecord && (
                    <>
                      <div>
                        <br />
                        <div
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                          }}
                        >
                          {' '}
                          Proof of Business
                        </div>
                        <hr style={lineStyle} />
                        <br />
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap', // Allow wrapping to the next row
                            justifyContent: 'space-between', // Evenly distribute space between images
                            marginBottom: '22px',
                          }}
                        >
                          {displayData?.pickupPointInfo?.kycDocument?.map((eachImages, eachInd) => (
                            <div
                              key={eachInd + 1}
                              className='image-input'
                              style={{width: '48%', marginBottom: '20px'}}
                            >
                              <div
                                onClick={() => handleClick(eachImages.docUrl)}
                                className='image-input-wrapper'
                                style={
                                  !isProcessingRecord
                                    ? {
                                        width: 163,
                                        height: 150,
                                        // backgroundSize: '400px',
                                        marginRight: '15px',
                                        // backgroundImage: `url(${eachImages})`,
                                        backgroundImage: `url(${eachImages})`,
                                      }
                                    : {
                                        width: '100%', // Full width of the container
                                        paddingBottom: '100%', // Maintain aspect ratio (square)
                                        backgroundImage: `url(${eachImages.docUrl})`,
                                        backgroundSize: 'cover', // Ensure the image covers the div
                                        backgroundPosition: 'center', // Center the image
                                        borderRadius: '8px', // Optional: add rounded corners
                                        backgroundRepeat: 'no-repeat', // Avoid repeating the image
                                      }
                                }
                              >
                                {/* Temporary check for image */}
                                {/* <img src={eachImages.docUrl} alt="Document" style={{ width: '100%' }} /> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  {(!isSupplyOrders &&
                    !isCollectOrders &&
                    displayData?.weightScale?.scannedImageUrl && (
                      <div>
                        {location.pathname !== '/apps/transactions/processing-record' && (
                          <div>
                            <div
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                              }}
                            >
                              {' '}
                              Calibration Record
                            </div>
                            <hr style={lineStyle} />
                            <div
                              onClick={() =>
                                handleClick(displayData?.weightScale?.scannedImageUrl || '')
                              }
                              className='image-input-wrapper'
                              style={{
                                width: 300,
                                height: 280,
                                marginRight: '15px',
                                backgroundImage: `url(${
                                  displayData?.weightScale?.scannedImageUrl || ''
                                })`,
                              }}
                            ></div>
                          </div>
                        )}
                      </div>
                    )) ||
                    null}
                  <div
                    style={{
                      background: 'white',
                      width: 'fit-content',
                      margin: '0px auto -22px',
                    }}
                  >
                    <div>
                      {/* <img
                    width={100}
                    height={25}
                    src='/media/svg/dashboard/asm-final-2.png'
                    alt='alt-img'
                  /> */}
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <img
                      src='/ff1.png'
                      alt='first image'
                      style={{
                        maxHeight: '50px', // adjust as needed
                        maxWidth: '100px',
                      }}
                    />
                    <img
                      src='/ff2.png'
                      alt='middle image'
                      style={{
                        maxHeight: '200px', // adjust as needed
                        maxWidth: '200px',
                      }}
                    />
                    <img
                      src='/fmg.png'
                      alt='last image'
                      style={{
                        // backgroundColor: '#FFFFFF',
                        maxHeight: '50px', // adjust as needed
                        maxWidth: '100px',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            style={{backgroundColor: '#12B886', color: 'white'}}
            className='btn btn-light-primary me-3 mb-4'
            type='button'
            onClick={downloadCertificate}
          >
            Download
          </button>
        </div>
      ) : (
        <div>
          <div
            ref={certificateRef}
            style={{
              position: 'relative',
              // padding: '20px',
              width: '100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top left, bottom right, center',
              backgroundSize: 'auto, auto, cover',
              fontFamily: 'Inter, Arial, sans-serif',
            }}
          >
            <div
              id='pdf-content'
              className='container'
              style={{
                position: 'relative',
                zIndex: 2,
              }}
            >
              <div className='row'>
                <div style={{background: '#03546e', color: 'white', padding: '10px'}}>
                  <div
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
                  >
                    {/* Left: Profile Image */}
                    <div>
                      <img
                        src={displayData?.kycDocuments?.docUrl}
                        alt=''
                        style={{
                          borderRadius: '8px',
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          border: '2px solid white',
                        }}
                      />
                    </div>

                    {/* Center: Text Content */}
                    <div style={{flex: 1, marginLeft: '20px'}}>
                      <p style={{fontSize: '25px', fontWeight: 'bold', margin: 0}}>
                        {isSupplyOrders
                          ? `${
                              pathname.includes('apps/transactions/items') ? 'Sale' : 'Dispatch'
                            } Receipt`
                          : changeInProcessingRecord
                          ? 'Production receipt'
                          : isProcessingRecord
                          ? 'Diversion Certificate'
                          : ' Collection receipt'}
                      </p>
                      <div style={{display: 'flex', gap: '10px', marginTop: '10px'}}>
                        <p
                          style={{
                            fontSize: '1.075rem',
                            color: '#d4e8f0',
                            margin: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          Document number: {displayData?.productionId || displayData?.id}
                        </p>
                        <p
                          style={{
                            fontSize: '1.075rem',
                            color: '#d4e8f0',
                            margin: 0,
                            fontWeight: 'bold',
                          }}
                        >
                          Date:{' '}
                          {displayData?.createdAt
                            ? new Date(displayData.createdAt).toISOString().split('T')[0]
                            : '-'}
                        </p>
                      </div>
                    </div>

                    {/* Right: Company Logo */}
                    <div>
                      {/* <img
        src="/fmg2.png"
        alt='Company Logo'
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain',
          filter: 'brightness(0) invert(1)' // Makes the image white
        }}
      /> */}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  fontFamily: 'Inter, Arial, sans-serif',
                  padding: '10px',
                }}
              >
                {/* <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    margin: '0',
                    padding: '0',
                    minHeight: '40px'
                  }}>
                    {displayData?.certifications?.length > 0 && (
                      displayData.certifications.map((certification, index) => (
                        <div
                          key={certification.id || index}
                          title={certification.certificationName}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            border: '2px solid #e9ecef',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                          }}
                          onClick={() => handleClick(certification.logo)}
                        >
                          <img
                            src={certification.logo}
                            alt={certification.certificationName}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        </div>
                      ))
                    )}
                  </div> */}

                <div
                  style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    marginBottom: '16px',
                    marginTop: '10px',
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#e6f0f3',
                      color: '#0a3d62',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      padding: '12px 16px',
                    }}
                  >
                    {changeInProcessingRecord
                      ? 'Facility information'
                      : isProcessingRecord
                      ? 'Diversion Facility'
                      : isReturnOrdersPage
                      ? 'Supplying facility'
                      : ' Source of waste'}
                  </div>
                  <div
                    style={{
                      padding: '16px',
                      display: 'flex',
                      gap: '24px',
                      alignItems: 'flex-start',
                    }}
                  >
                    <div style={{flex: '0 0 60%'}}>
                      {(isProcessingRecord
                        ? diverisonName
                        : isReturnOrdersPage
                        ? collectionData
                        : depositerName
                      ).map((eachData, ind) => (
                        <div
                          key={ind + 1 + ''}
                          style={{
                            fontSize: '14px',
                            marginBottom: '8px',
                            paddingBottom: '8px',
                            display: 'flex',
                            gap: '8px',
                            borderBottom: '1px solid #f1f5f9',
                          }}
                        >
                          <label
                            style={{color: '#242727', fontWeight: '700', minWidth: 'fit-content'}}
                          >
                            {eachData.label}
                          </label>
                          <span style={{color: '#4F5152'}}>: {eachData.value}</span>
                        </div>
                      ))}
                    </div>
                    {/* <div style={{ flex: '0 0 35%', height: '200px', borderRadius: '8px', overflow: 'hidden' }}>
                        <MapComponentCerti
                          data={[
                            {
                              name: displayData?.pickupPointName || displayData?.customerInfo?.name || 'Location 1',
                              position: {
                                lat: isProcessingRecord
                                  ? parseFloat(displayData?.pickupPointInfo?.address?.latitute) || 28.7041
                                  : isReturnOrdersPage
                                    ? parseFloat(displayData?.centreInfo?.address?.latitute) || 28.7041
                                    : parseFloat(displayData?.latitude) || 28.7041,
                                lng: isProcessingRecord
                                  ? parseFloat(displayData?.pickupPointInfo?.address?.longitute) || 77.1025
                                  : isReturnOrdersPage
                                    ? parseFloat(displayData?.centreInfo?.address?.longitute) || 77.1025
                                    : parseFloat(displayData?.longitude) || 77.1025
                              }
                            }
                          ]}
                          zooms={10}
                        />
                      </div> */}

                    <div
                      style={{
                        flex: '0 0 35%',
                        height: '200px',
                        minHeight: '200px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        position: 'relative',
                      }}
                    >
                      <MapComponentCerti
                        data={[
                          {
                            name:
                              displayData?.pickupPointName ||
                              displayData?.customerInfo?.name ||
                              'Location 1',
                            position: {
                              lat: isProcessingRecord
                                ? parseFloat(displayData?.pickupPointInfo?.address?.latitute) ||
                                  28.7041
                                : isReturnOrdersPage
                                ? parseFloat(displayData?.centreInfo?.address?.latitute) || 28.7041
                                : parseFloat(displayData?.latitude) || 28.7041,
                              lng: isProcessingRecord
                                ? parseFloat(displayData?.pickupPointInfo?.address?.longitute) ||
                                  77.1025
                                : isReturnOrdersPage
                                ? parseFloat(displayData?.centreInfo?.address?.longitute) || 77.1025
                                : parseFloat(displayData?.longitude) || 77.1025,
                            },
                          },
                        ]}
                        zooms={14}
                      />
                    </div>
                  </div>
                </div>

                {/* {shouldShowMaterialDetails && (
                    <div style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px'
                    }}>
                      <div style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <span>Material details</span>

                        {displayData?.specialCharacteristics && displayData.specialCharacteristics.length > 0 && (
                          <div style={{ display: 'flex', gap: '8px' }}>
                            {displayData.specialCharacteristics.map((characteristic, index) => (
                              <div
                                key={index}
                                style={{
                                  backgroundColor: '#d0bdf9',
                                  color: '#7239ea',
                                  padding: '4px 8px',
                                  borderRadius: '6px',
                                  fontSize: '12px',
                                  fontWeight: 'bold'
                                }}
                              >
                                {characteristic.replace(/_/g, ' ')}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )} */}

                {location.pathname !== '/apps/transactions/processing-record' &&
                  materialDetailsTable()}

                {location.pathname === '/apps/transactions/processing-record' && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <div> Material details</div>

                        <div>
                          {shouldShowMaterialDetails &&
                            displayData?.specialCharacteristics &&
                            displayData.specialCharacteristics.length > 0 && (
                              <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                {displayData.specialCharacteristics.map((characteristic, index) => (
                                  <div
                                    key={index}
                                    className='px-1 py-0.5 border border-gray-300 rounded-lg text-xs font-bold'
                                    style={{
                                      backgroundColor: '#d0bdf9',
                                      color: '#7239ea',
                                      marginLeft: '8px',
                                    }}
                                  >
                                    {characteristic.replace(/_/g, ' ')}
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                    <table className='table table-hover table-rounded border gy-4 gs-7'>
                      <thead>
                        <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                          <th style={{maxWidth: '1px'}}>SL</th>
                          <th>Type</th>
                          <th>Category</th>
                          <th>Item</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(displayData?.inputMaterial || []).map((row, index) => (
                          <tr key={index} className='text-center'>
                            <td>{index + 1}</td>
                            <td>Input Material</td>
                            <td>{row.inputMaterialCategoryName || '-'}</td>
                            <td>{row.inputMaterialName || '-'}</td>
                            <td>{parseFloat(row.inputQuantity || 0).toFixed(2)} kg</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {location.pathname === '/apps/transactions/processing-record' && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      <span>
                        Process name:{' '}
                        <span
                          style={{
                            backgroundColor: '#d0bdf9',
                            color: '#7239ea',
                            borderRadius: '6px',
                            padding: '2px 6px',
                            fontSize: '12px',
                          }}
                        >
                          {displayData?.processName}
                        </span>
                      </span>
                    </div>
                    <table className='table table-hover table-rounded border gy-4 gs-7'>
                      <thead>
                        <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                          <th style={{maxWidth: '1px'}}>SL</th>
                          <th>Type</th>
                          <th>Category</th>
                          <th>Item</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(displayData?.productionItemDetails || []).map((row, index) => (
                          <tr key={index} className='text-center'>
                            <td>{index + 1}</td>
                            <td>Output Material</td>
                            <td>{row.categoryName || '-'}</td>
                            <td>{row.itemName || '-'}</td>
                            <td>{row.quantity || '-'} kg</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {(location.pathname === '/apps/transactions/collect-orders' ||
                  location.pathname === '/apps/transactions/items') && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      Remarks
                    </div>
                    <div
                      style={{
                        padding: '16px',
                        fontSize: '12px',
                        color: '#212529',
                        lineHeight: '1.5',
                      }}
                    >
                      {displayData?.remarks || 'No remarks available'}
                    </div>
                  </div>
                )}

                {(isReturnOrdersPage && (
                  <>
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        marginBottom: '16px',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: '#e6f0f3',
                          color: '#0a3d62',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '12px 16px',
                        }}
                      >
                        {location.pathname === '/apps/transactions/items'
                          ? 'Customer Information'
                          : ' Receiving facility'}
                      </div>
                      <div style={{padding: '16px'}}>
                        {receivingFacility?.map((eachData, ind) => (
                          <div
                            key={ind + 1 + ''}
                            style={{
                              fontSize: '14px',
                              marginBottom: '8px',
                              display: 'flex',
                              gap: '8px',
                            }}
                          >
                            <label
                              style={{color: '#242727', fontWeight: '700', minWidth: 'fit-content'}}
                            >
                              {eachData.label}
                            </label>
                            <span style={{color: '#4F5152'}}>: {eachData.value}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {location.pathname === '/apps/transactions/supply-orders' && (
                      <div
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '150px',
                          margin: '20px 0',
                        }}
                      >
                        <div
                          style={{
                            width: '140px',
                            height: '80px',
                            backgroundColor: 'white',
                            color: 'black',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'absolute',
                            left: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            borderRadius: '5px',
                            padding: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                          }}
                        >
                          {displayData.pickupPointName}
                        </div>

                        <div
                          style={{
                            width: '140px',
                            height: '80px',
                            backgroundColor: 'white',
                            color: 'black',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'absolute',
                            right: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            borderRadius: '5px',
                            padding: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                          }}
                        >
                          {displayData?.toPickupPointName}
                        </div>

                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '140px',
                            right: '140px',
                            height: '2px',
                            backgroundColor: 'black',
                            transform: 'translateY(-50%)',
                          }}
                        />

                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -150%)',
                            backgroundColor: 'white',
                            padding: '4px 8px',
                            fontWeight: 'bold',
                            boxShadow: '0 0 3px rgba(0,0,0,0.1)',
                          }}
                        >
                          {displayData.routeLength}, {displayData.transportType}
                        </div>
                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, 50%)',
                            backgroundColor: 'white',
                            padding: '4px 8px',
                            fontWeight: 'bold',
                            boxShadow: '0 0 3px rgba(0,0,0,0.1)',
                          }}
                        >
                          {displayData.status === 'Created'
                            ? 'In transit'
                            : displayData.status === 'Completed'
                            ? 'Delivered'
                            : displayData.status}
                        </div>
                      </div>
                    )}
                  </>
                )) || (
                  <>
                    {pathname.includes('apps/transactions/processing-record') && (
                      <div
                        style={{
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          marginBottom: '16px',
                        }}
                      >
                        <div style={{padding: '16px'}}>
                          <div
                            style={{
                              fontSize: '14px',
                              marginBottom: '20px',
                              display: 'flex',
                              gap: '8px',
                            }}
                          >
                            <label
                              style={{color: '#242727', fontWeight: '700', minWidth: 'fit-content'}}
                            >
                              Process loss
                            </label>
                            <span style={{color: '#4F5152'}}>
                              : &nbsp;&nbsp;
                              <span
                                style={{
                                  backgroundColor: '#fdb3c6',
                                  color: '#f7285a',
                                  borderRadius: '6px',
                                  padding: '2px 6px',
                                  fontSize: '12px',
                                }}
                              >
                                {parseFloat(displayData.wastage || 0).toFixed(2)}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        marginBottom: '16px',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: '#e6f0f3',
                          color: '#0a3d62',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '12px 16px',
                        }}
                      >
                        {changeInProcessingRecord
                          ? 'Production information'
                          : isProcessingRecord
                          ? 'Diversion Information'
                          : 'Facility information'}
                      </div>
                      <div style={{padding: '16px'}}>
                        <div className='row'>
                          <div className='col-12'>
                            {(isProcessingRecord ? diversionInformation : collectorDetails).map(
                              (eachData, ind) => (
                                <div
                                  key={ind + 1 + ''}
                                  style={{
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'flex',
                                    gap: '8px',
                                  }}
                                >
                                  <label
                                    style={{
                                      color: '#242727',
                                      fontWeight: '700',
                                      minWidth: 'fit-content',
                                    }}
                                  >
                                    {eachData.label}
                                  </label>
                                  <span style={{color: '#4F5152'}}>: {eachData.value}</span>
                                </div>
                              )
                            )}
                          </div>
                          <div className='col-3'>
                            {isAudited && (
                              <img
                                style={{backgroundColor: '#FFFFFF', marginTop: '1px'}}
                                src={toAbsoluteUrl('/media/misc/audilogo.png')}
                                alt='main-logo'
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isProcessingRecord && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      Chain of custody
                    </div>
                    <div style={{padding: '16px'}}>
                      <div className='row'>
                        {displayData.images?.map((eachData, ind) => (
                          <div className='col-lg-4' key={ind}>
                            <img
                              width='100px'
                              height='100px'
                              src={eachData || ''}
                              alt='main-logo'
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {!isSupplyOrders && !isCollectOrders && displayData?.certifications?.length && (
                  <>
                    {location.pathname !== '/apps/transactions/processing-record' && (
                      <div
                        style={{
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          marginBottom: '16px',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#e6f0f3',
                            color: '#0a3d62',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            padding: '12px 16px',
                          }}
                        >
                          Certifications
                        </div>
                        <table className='table table-hover table-rounded border gy-4 gs-7'>
                          <thead>
                            <tr className='fw-bold text-gray-800 border-bottom-2 border-gray-200 text-center'>
                              <th style={{minWidth: '4px'}}>S.N</th>
                              <th>Certificate name</th>
                              <th>Number</th>
                              <th>Issued by</th>
                              <th>Issued on</th>
                            </tr>
                          </thead>
                          <tbody>
                            {displayData?.certifications?.map((eachCertification, eachInd) => (
                              <tr key={eachInd + 1 + ''} className='text-center'>
                                <td>{eachInd + 1 + ''}</td>
                                <td>{eachCertification.certificationName}</td>
                                <td>{eachCertification.certificationNo}</td>
                                <td>{eachCertification.issuingAuthorities}</td>
                                <td>
                                  {eachCertification.issuedOn
                                    ? new Date(eachCertification.issuedOn).toLocaleDateString()
                                    : '-'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}

                {isAudited && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      Auditor Information
                    </div>
                    <div style={{padding: '16px'}}>
                      <div className='row'>
                        <div className='col-9'>
                          {auditorInformation.map((eachData, ind) => (
                            <div
                              key={ind + 1 + ''}
                              style={{
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'flex',
                                gap: '8px',
                              }}
                            >
                              <label
                                style={{
                                  color: '#242727',
                                  fontWeight: '700',
                                  minWidth: 'fit-content',
                                }}
                              >
                                {eachData.label}
                              </label>
                              <span style={{color: '#4F5152'}}>: {eachData.value}</span>
                            </div>
                          ))}
                        </div>
                        <div className='col-3'>
                          <div>
                            <img
                              width='100px'
                              height='100px'
                              src={displayData.sign || ''}
                              alt='main-logo'
                            />
                          </div>
                          <div
                            style={{
                              fontSize: '18px',
                              fontWeight: 'bold',
                            }}
                          >
                            Signature
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!changeInProcessingRecord && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      Chain of custody
                    </div>
                    <div style={{padding: '16px'}}>
                      {isProcessingRecord && (
                        <>
                          {Object.keys(mapList).map((x) => (
                            <div key={x}>
                              <div
                                style={{
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                }}
                              >
                                {capitalizeWords(x)}
                              </div>
                              <hr style={lineStyle} />
                              <div style={{marginBottom: '16px'}}>Supply chain Traceability</div>
                              {x === 'proofOfDiversion' && materialDetailsTable()}
                              {renderDataRecursively(dataMap[x], x)}
                            </div>
                          ))}
                        </>
                      )}

                      {displayData?.images?.length ? (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            gap: '15px',
                            marginBottom: '22px',
                          }}
                        >
                          {displayData.images.slice(0, 3).map((eachImages, eachInd) => (
                            <div
                              key={eachInd + 1}
                              className='image-input'
                              style={{width: '163px', height: '150px'}}
                            >
                              <div
                                onClick={() => handleClick(eachImages)}
                                className='image-input-wrapper'
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  backgroundImage: `url(${eachImages})`,
                                  backgroundSize: 'cover',
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                }}
                              />
                            </div>
                          ))}

                          {location.pathname === '/apps/transactions/items' &&
                            displayData.orderConfirmedImages &&
                            displayData.orderConfirmedImages.map((fileUrl, fileInd) => (
                              <div
                                key={`file-${fileInd}`}
                                className='file-input'
                                style={{width: '163px', height: '150px'}}
                              >
                                <img
                                  src={fileUrl}
                                  alt='Order confirmation'
                                  style={{display: 'none'}}
                                  onLoad={(e) => {
                                    const container = (e.target as HTMLImageElement).parentElement
                                    const imageDiv = container?.querySelector(
                                      '.image-display'
                                    ) as HTMLElement
                                    const pdfDiv = container?.querySelector(
                                      '.pdf-display'
                                    ) as HTMLElement
                                    if (imageDiv && pdfDiv) {
                                      imageDiv.style.display = 'block'
                                      pdfDiv.style.display = 'none'
                                    }
                                  }}
                                  onError={(e) => {
                                    const container = (e.target as HTMLImageElement).parentElement
                                    const imageDiv = container?.querySelector(
                                      '.image-display'
                                    ) as HTMLElement
                                    const pdfDiv = container?.querySelector(
                                      '.pdf-display'
                                    ) as HTMLElement
                                    if (imageDiv && pdfDiv) {
                                      imageDiv.style.display = 'none'
                                      pdfDiv.style.display = 'block'
                                    }
                                  }}
                                />

                                <div
                                  className='image-display'
                                  onClick={() => handleClick(fileUrl)}
                                  style={{
                                    display: 'none',
                                    cursor: 'pointer',
                                    width: '100%',
                                    height: '100%',
                                    backgroundImage: `url(${fileUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    borderRadius: '8px',
                                  }}
                                />

                                <div
                                  className='pdf-display'
                                  onClick={() => window.open(fileUrl, '_blank')}
                                  style={{
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    width: '100%',
                                    height: '100%',
                                    lineHeight: '150px',
                                    backgroundColor: '#f8f9fa',
                                    border: '2px solid #dee2e6',
                                    borderRadius: '8px',
                                  }}
                                >
                                  <i
                                    className='fas fa-file-pdf'
                                    style={{
                                      fontSize: '60px',
                                      color: '#dc3545',
                                      verticalAlign: 'middle',
                                    }}
                                  ></i>
                                </div>
                              </div>
                            ))}

                          <div
                            style={{
                              display: 'inline-block',
                              verticalAlign: 'top',
                              marginLeft: '15px',
                            }}
                          >
                            <div
                              style={{
                                fontFamily: 'Best Signature Font',
                                fontSize: '22px',
                                marginTop: '-6px',
                              }}
                            >
                              {displayData.createdByName}
                            </div>
                            <div
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                              }}
                            >
                              Signature
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}

                {!changeInProcessingRecord && isProcessingRecord && (
                  <div
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: '#e6f0f3',
                        color: '#0a3d62',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        padding: '12px 16px',
                      }}
                    >
                      Proof of Business
                    </div>
                    <div style={{padding: '16px'}}>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          justifyContent: 'space-between',
                          gap: '16px',
                        }}
                      >
                        {displayData?.pickupPointInfo?.kycDocument?.map((eachImages, eachInd) => (
                          <div
                            key={eachInd + 1}
                            className='image-input'
                            style={{width: '48%', paddingBottom: '48%', position: 'relative'}}
                          >
                            <div
                              onClick={() => handleClick(eachImages.docUrl)}
                              className='image-input-wrapper'
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundImage: `url(${eachImages.docUrl})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                borderRadius: '8px',
                                backgroundRepeat: 'no-repeat',
                                cursor: 'pointer',
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {!isSupplyOrders && !isCollectOrders && displayData?.weightScale?.scannedImageUrl && (
                  <>
                    {location.pathname !== '/apps/transactions/processing-record' && (
                      <div
                        style={{
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          marginBottom: '16px',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#e6f0f3',
                            color: '#0a3d62',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            padding: '12px 16px',
                          }}
                        >
                          Calibration Record
                        </div>
                        <div style={{padding: '16px'}}>
                          <div
                            onClick={() =>
                              handleClick(displayData?.weightScale?.scannedImageUrl || '')
                            }
                            className='image-input-wrapper'
                            style={{
                              width: '300px',
                              height: '280px',
                              backgroundImage: `url(${
                                displayData?.weightScale?.scannedImageUrl || ''
                              })`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              borderRadius: '8px',
                              cursor: 'pointer',
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <button
            style={{backgroundColor: '#12B886', color: 'white'}}
            className='btn btn-light-primary me-3 mb-4'
            type='button'
            onClick={downloadCertificate}
          >
            Download
          </button>
        </div>
      )}
    </>
  )
}

export default CertificateComponent
